import type { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { Drawer } from "@unified-checkout/design-system";

import type { TDrawer } from "@app/dashboard/types/innerLayout/disputes";
import { AcceptDispute } from "./Accept";
import { ChallengeDispute } from "./Challenge";

import styles from "./drawers.module.scss";


export const Drawers = ({
  isOpen,
  setIsDrawerOpen,
  data
}: {
  isOpen: Record<TDrawer, boolean>,
  setIsDrawerOpen: Dispatch<SetStateAction<Record<TDrawer, boolean>>>,
  data: {
    disputeId: string,
    reason?: string,
    disputedAmount: number,
    currency: string
  }
}
) => {
  const { t } = useTranslation();

  const drawersData = {
    challenge: {
      title: t('innerLayout.disputesPage.drawers.challenge.title'),
      hint: t('innerLayout.disputesPage.drawers.challenge.hint'),
      body: <ChallengeDispute disputeId={data.disputeId} setIsDrawerOpen={setIsDrawerOpen} />,
    },
    accept: {
      title: t('innerLayout.disputesPage.drawers.accept.title'),
      hint: t('innerLayout.disputesPage.drawers.accept.hint'),
      body: <AcceptDispute {...data} setIsDrawerOpen={setIsDrawerOpen} />,
    }
  };


  return (
    Object.entries(isOpen).map(([step, open]) => {
      const stepData = drawersData[step as TDrawer];

      return (
        <Drawer
          wrapperClassName="drawer-body"
          closeOnClickOutside={false}
          hasCloseIcon
          onCloseHandler={() => setIsDrawerOpen((prev) => ({ ...prev, [step]: false }))}
          open={open}
          key={step}
          isOverlayAboveModal
        >
          <div className={styles["drawer-body"]}>

            <div className={styles["drawer-body__header"]}>

              <div className={styles["drawer-body__header__title"]}>
                {stepData.title}
              </div>

              <div className={styles["drawer-body__header__hint"]}>
                {stepData.hint}
              </div>
            </div>

            <div className={styles["drawer-body__main"]}>
              {stepData.body}
            </div>

          </div>
        </Drawer>
      )
    })
  )
}